/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EdicionEncuestaDto } from '../../models/edicion-encuesta-dto';

export interface DoctorEncuestasControllerEditarEncuesta$Params {

/**
 * UUID de la encuesta a editar
 */
  uuidEncuesta: string;
  
    /**
     * Datos de la encuesta a editar
     */
    body: EdicionEncuestaDto
}

export function doctorEncuestasControllerEditarEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerEditarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerEditarEncuesta.PATH, 'put');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

doctorEncuestasControllerEditarEncuesta.PATH = '/api/doctor-encuestas/editar-encuesta/{uuidEncuesta}';
